import { SideStatisticsProps } from '@ahc-digital/component-library';
import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { getDroplink } from 'src/shared/param-utils';
import { SIDE_STATISTICS_CONTAINER } from 'src/shared/static';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { C51SideStatisticsProps } from './C51SideStatistics.types';

export function CreateSideStatisticsModel(props?: C51SideStatisticsProps): SideStatisticsProps {
  type t = SideStatisticsProps;

  const { rendering, params, fields } = props || {};

  const { renderText, renderRichText, renderLink } = useConditionalRendering();

  return {
    backgroundColor: getDroplink<t['backgroundColor']>(params?.BackgroundColor, 'white'),
    headlineTag: getDroplink<t['headlineTag']>(params?.HeadlineTag, 'p'),
    contentAlignments: getDroplink<t['contentAlignments']>(params?.ContentAlignments, 'center'),
    ctaAlignment: getDroplink<t['ctaAlignment']>(params?.CtaAlignment, 'center'),
    headline: renderText(fields?.Headline),
    supportCopy: renderRichText(fields?.SupportCopy),
    supportCopyBottom: renderRichText(fields?.SupportCopyBottom),
    cta: renderLink(fields?.Cta),
    children: rendering && (
      <Placeholder
        name={`${SIDE_STATISTICS_CONTAINER}-${params?.DynamicPlaceholderId}`}
        rendering={rendering}
      />
    ),
  };
}
